import { FvBoxAnchor, FvBoxVersion } from 'src/models/anchor-and-version/fv-box.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AnchorAndVersionBaseService } from './anchor-and-version-base.service';
import { AuthService } from '../auth.service';
import { ConfigState } from 'src/store/reducers/config.reducer';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';

export interface EditFvBoxFkKeysDto {
    key: number;
    sourceAeBoxAnchorKey: number;
    targetAeBoxAnchorKey: number;
    sourceAddressAnchorKey: number | null;
    targetAddressAnchorKey: number | null;
}

@Injectable({ providedIn: 'root' })
export class FvBoxService extends AnchorAndVersionBaseService<FvBoxAnchor, FvBoxVersion> {
    protected authService = inject(AuthService);
    protected baseUrl = '/api/fvbox';
    protected http = inject(HttpClient);
    protected store = inject<Store<{ config: ConfigState }>>(Store);

    public async editFkKeys(dto: EditFvBoxFkKeysDto): Promise<FvBoxAnchor> {
        const params = new HttpParams().append('workspace', await this.getWorkspaceKey());

        return firstValueFrom(
            this.http.put<FvBoxAnchor>(`${this.baseUrl}/edit-fk-keys`, dto, {
                headers: await this.createHeaders(),
                params,
            })
        );
    }
}
